import MaskedInput from "antd-mask-input";
export default MaskedInput;
